"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const ROWS = Array.from({ length: 18 }, (_, index) => `finishingOfferRow${index + 1}`) as [
	"finishingOfferRow1",
	"finishingOfferRow2",
	"finishingOfferRow3",
	"finishingOfferRow4",
	"finishingOfferRow5",
	"finishingOfferRow6",
	"finishingOfferRow7",
	"finishingOfferRow8",
	"finishingOfferRow9",
	"finishingOfferRow10",
	"finishingOfferRow11",
	"finishingOfferRow12",
	"finishingOfferRow13",
	"finishingOfferRow14",
	"finishingOfferRow15",
	"finishingOfferRow16",
	"finishingOfferRow17",
	"finishingOfferRow18",
];

export default function SurfaceFinishingOffer() {
	const t = useTranslations("new-surface-finishing");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("finishingOfferTitle")}
					</h2>
				</header>

				<div className="overflow-x-auto">
					<table className="w-full border-collapse">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="w-[19%] px-6 py-5 text-left text-sm font-bold md:text-base">
									{t("finishingOfferColFinish")}
								</th>
								<th className="w-[37%] px-6 py-5 text-left text-sm font-bold md:text-base">
									{t("finishingOfferColDescription")}
								</th>
								<th className="w-[22%] px-6 py-5 text-left text-sm font-bold md:text-base">
									{t("finishingOfferColServices")}
								</th>
								<th className="w-[22%] px-6 py-5 text-left text-sm font-bold md:text-base">
									{t("finishingOfferColMaterials")}
								</th>
							</tr>
						</thead>
						<tbody className="border-b border-[#c4c5c4]">
							{ROWS.map((row) => (
								<tr key={row} className="border-b border-[#c4c5c4] last:border-b-0">
									<td className="px-6 py-5 align-middle text-sm font-bold text-black md:py-6 md:text-base">
										{t(`${row}Finish`)}
									</td>
									<td className="px-6 py-5 align-middle text-sm leading-relaxed text-black md:py-6 md:text-base">
										{t(`${row}Description`)}
									</td>
									<td className="px-6 py-5 align-middle text-sm leading-relaxed text-black md:py-6 md:text-base">
										{t(`${row}Services`)}
									</td>
									<td className="px-6 py-5 align-middle text-sm leading-relaxed text-black md:py-6 md:text-base">
										{t(`${row}Materials`)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="mt-8 flex justify-center sm:mt-10 md:mt-12">
					<Link
						href="/contact-us"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("finishingOfferContactCta")}
					</Link>
				</div>
			</div>
		</section>
	);
}
